import React, { useEffect, useState } from 'react';
import { DataContext } from '../../../Context/DataContext';
// import 'antd/dist/antd.css';
import { Input, Radio, message, Spin, Modal, Button, Row, Col, Form } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import efn from './AgendaFns'
import './Agenda.scss';
import moment from 'moment';


function Agenda(props) {
    const { globalData } = React.useContext(DataContext)
    const navigate = useNavigate()
    const location = useLocation()
    const { TextArea } = Input
    const [agenda, setAgenda] = useState({})
    const [isPageLoading, setIsPageLoading] = useState(true)
    const setFuncMap = {
        message, setIsPageLoading, setAgenda
    }
    useEffect(() => {
        efn.getAgenda(setFuncMap)
    }, [globalData.langChangeTime]);
    return (
        <Spin spinning={isPageLoading}>
            <div className="UserAgenda">
                {agenda.lastUpdateAt && <div className="last-update-at">{`最後更新時間 ${moment(agenda.lastUpdateAt).format("yyyy-MM-DD HH:mm:ss")}`}</div>}
                <div className="main" dangerouslySetInnerHTML={{ __html: agenda.content }}></div>
            </div>
        </Spin>
    );
}



export default Agenda;
